import Vue from 'vue'

Vue.directive('in-viewport', {
  inserted: (el, binding) => {
    let f = () => {
      let rect = el.getBoundingClientRect()
      let inView = !(rect.bottom < 0 || rect.top > (window.innerHeight || document.documentElement.clientHeight))
      if (inView) {
        binding.value()
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f, { passive: true })
    f()
  }
})



// WEBPACK FOOTER //
// ./src/plugins/directives.js